import React from "react";
import Content from "./Content";
import {
    getDataTable,
    sendSaleIdsToServer, getDataTableForRegularPrices, addPromosToPrintListDispatcher, addItemsToPrintListDispatcher
} from "../../Redux/content-reducer";
import {connect} from "react-redux";
import Preloader from "../Preloader/Preloader";
import {getFormat} from "../../Redux/format-reducer";


class ContentContainer extends React.Component {
    componentDidMount() {
        const selectedOptionValue = localStorage.getItem('selectedOptionValue') && localStorage.getItem('selectedOptionValue') !== "undefined" ? localStorage.getItem('selectedOptionValue') : '9';
        const format = this.props.data.dropdownsReducer.format;
        const supplierName = null;
        const productCategoryName = null;
        if(this.props.data.contentData.isActivePromosScreen){
            this.props.getDataTable(selectedOptionValue, format, supplierName, productCategoryName, this.props.data.contentData.searchValue);
        } else {
            this.props.getDataTableForRegularPrices(selectedOptionValue, format, supplierName, productCategoryName, this.props.data.contentData.searchValue);
        }
    }

    render() {
        if(this.props.data.contentData.isPreloader){
            return (
                <Preloader/>
            )
        } else {
            return (
                <Content data={this.props}/>
            )
        }
    }
}


let mapStateToProps = (state) => {
    return {
        data: state
    }
};

let mapDispatchToProps = {getDataTable, getFormat, sendSaleIdsToServer, getDataTableForRegularPrices, addPromosToPrintListDispatcher, addItemsToPrintListDispatcher};

export default connect(mapStateToProps, mapDispatchToProps)(ContentContainer);